import axios from "../../../../apis/Api";
import history, { logout } from "../../../../history";
import storage from "../../../../apis/Storage";
import {
  GET_ORDER_SHOP_DETAILS,
  ADD_ORDER_SHOP_DETAILS,
  GET_SINGLE_ORDER_SHOP_DETAILS,
} from "../../../../Types";
import { toast } from "react-toastify";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import * as XLSX from "xlsx";
import fileSaver from "file-saver";

export const getOrderShopDetails = (postedData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/ShopOrder/OrderShopDetails`, postedData)
    .then(({ data }) => {
      // if (data && data.length > 0)
      dispatch({
        type: GET_ORDER_SHOP_DETAILS,
        payload: data.response,
      });
      dispatch(hideLoading());
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response)
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message,
          );
        else {
          toast.error("Error while processing the request");
        }
    });
};

export const getSingleOrderShopDetails = (id) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .get(`api/ShopOrder/${id}`)
    .then(({ data }) => {
      dispatch({
        type: GET_SINGLE_ORDER_SHOP_DETAILS,
        payload: data.response,
      });
      dispatch(hideLoading());
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message,
          );
        else {
          toast.error("Error while processing the request");
        }
      }
    });
};

export const addOrderShopDetails = (formValues) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post("api/Authenticate/CreateUser", formValues)
    .then(({ data }) => {
      // if (data && data.length > 0)
      dispatch({
        type: ADD_ORDER_SHOP_DETAILS,
        payload: data.response,
      });
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message,
          );
        else {
          toast.error("Error while processing the request");
        }
      }
    });
};

export const downloadJob = (requestData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/ShopOrder/ExportOrderShopDetails`, requestData)
    .then(({ data }) => {
      // ;
      const outputFilename = `Order_Payment_Status_Shop_Details_Report${Date.now()}`;
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";

      const exportToCSV = (csvData, jobNumber, fileName) => {
        const ws = XLSX.utils.json_to_sheet(csvData);
        if (ws) {
          var range = XLSX.utils.decode_range(ws["!ref"]);
          for (var C = range.s.c; C <= range.e.c; ++C) {
            var address = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
            if (!ws[address]) continue;
            ws[address].v =
              ws[address].v == "distributor"
                ? "Distributor"
                : ws[address].v == "distCenterName"
                  ? "Distribution Center"
                  : ws[address].v == "vizId"
                    ? "Viz LinkId"
                    : ws[address].v == "shopCode"
                      ? "Shop Code"
                      : ws[address].v == "shopName"
                        ? "Shop Name"
                        : ws[address].v == "dateOfRequest"
                          ? "Date Of Request"
                          : ws[address].v == "amount"
                            ? "Order Amount"
                            : ws[address].v == "paidAmount"
                              ? "Paid Amount"
                              : ws[address].v == "paymentStatus"
                                ? "Payment Status"
                                : ws[address].v == "orderDeliveryDate"
                                  ? "Order Delivery Date"
                                  : ws[address].v == "taggedAgents"
                                    ? "Tagged Agents"
                                    : ws[address].v;
          }
        }
        // var sheetName = `Job_Number_${jobNumber}`
        const wb = {
          Sheets: { data: ws },
          SheetNames: [`data`],
        };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const fileData = new Blob([excelBuffer], { type: fileType });
        fileSaver.saveAs(fileData, fileName + fileExtension);
      };
      exportToCSV(data?.response, "", outputFilename);
      dispatch(hideLoading());
    })

    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message,
          );
        else {
          toast.error("Error while processing the request");
        }
      }
    });
};
